import api from '@/api'
import LeadSearchRequest from '@/model/lead/LeadSearchRequest'

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/lead/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllLeads(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/lead/get/all',
          LeadSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
},
}
